import { useDataProvider } from "react-admin";
import useSWR from "swr";

export function useTenant(id) {
	const dataProvider = useDataProvider();

	const { data: tenant, ...rest } = useSWR(["tenant", id], async () => {
		if (!id) {
			return;
		}
		const { data } = await dataProvider.getOne("tenants", { id });
		return data;
	});

	return { tenant, ...rest };
}
